// src/api/sales.js
import { post, get, put, del } from "./api";

export const createSale = (payload) => post("/create-sale", payload);
export const getRetailerInfo = (id) => get(`/retailer-info/${id}`);
export const getStockInfo = (productId) => get(`/stock-info/${productId}`);
export const getOffers = () => get("/available-offers");
export const getSaleHistory = (params) => get("/sales", { params });

// Sale detailed apis
export const getSaleById = (saleId) => get(`/sales/${saleId}`);
export const getSaleItems = (saleId, params) =>
  get(`/sales/${saleId}/items`, { params });
export const getSalePayments = (saleId, params) =>
  get(`/sales/${saleId}/payments`, { params });
export const collectPayment = (payload) =>
  post(`/sales/${payload.saleId}/payments`, payload);
export const updatePayment = (payload) =>
  put(`/sales/${payload.saleId}/payments/${payload.paymentId}`, payload);
export const deletePayment = (payload) =>
  del(`/sales/${payload.saleId}/payments/${payload.paymentId}`);
export const deleteSale = (saleId) => del(`/sales/${saleId}`);
export const createReturn = (payload) => post(`/sales/return`, payload);
